import script from "./publish.vue?vue&type=script&lang=ts&setup=true"
export * from "./publish.vue?vue&type=script&lang=ts&setup=true"

import "./publish.vue?vue&type=style&index=0&id=568e712d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-568e712d"]])

export default __exports__